// variant name marty looks for by default
export const FEATURE_ENABLED_VARIANT_NAME_TREATMENT = 'treatment';
/*
 * Feature Flags
 */
export const FEATURE_BANNER_ADS = 'discovery.sponsored.ads.ab.banner.ads';
export const FEATURE_BANNER_ADS_TOP_OF_SEARCH = 'marty.top.of.search.ads';
export const FEATURE_CALYPSO_AKAMAI_CALL = 'calypso.akamai.call';
export const FEATURE_CHECKOUT_PAYPAL_KILL_SWITCH = 'marty.checkout.3rdpp.paypal.turnOff';
export const FEATURE_CHECKOUT_LATENCY_OPTIMIZATION = 'kratos.checkout.latency.optimization.v2';
export const FEATURE_CONTENT_SQUARE_KILLSWITCH = 'marty.content.square';
export const FEATURE_GOODS_LABEL_ENDPOINT = 'marty.goods.label.endpoint';
export const FEATURE_HOMEPAGE_BANNER_ADS = 'discovery.homepage.sponsored.ads.ab.banner.ads';
export const FEATURE_LANDING_PAGE_KRATOS = 'marty.landing.page.kratos';
export const FEATURE_HOME_PAGE_KRATOS = 'marty.homepage.kratos';
export const FEATURE_LEFT_IN_STOCK = 'search.ab.left.in.stock';
export const FEATURE_MAFIA_AKAMAI = 'marty.mafia.akamai';
export const FEATURE_FEE_DEVTOOLS = 'kratos.fee.devtools';
export const FEATURE_MARTY_CLIENT_RENDER = 'marty.client.side.render';
export const FEATURE_MY_ACCOUNT_REDESIGN = 'marty.account.redesign';
export const FEATURE_PAGINATION_REDESIGN = 'marty.pagination.redesign';
export const FEATURE_NAV_REDESIGN = 'web.nav.shop.tab';
export const FEATURE_NAV_CLICKMES_CTA = 'web.nav.clickmes.cta';
export const FEATURE_NAV_SHOP_BIAS = 'web.nav.shop.bias';
export const FEATURE_PERCENT_DISCOUNT_SORT = 'search.ab.percent.discount.sort';
export const FEATURE_KRATOS_PAYMENTS_ADDRESS_PAGES_RELEASE = 'kratos.payments.addresses.pages.release';
export const FEATURE_PDP_LABOR_DAY_SALE = 'marty.pdp.labor.day';
export const FEATURE_PDP_OOS_UX = 'marty.pdp.oos.ux';
export const FEATURE_PDP_CLOUDCAT_DIRECT = 'marty.pdp.cloudcat.akamai';
export const FEATURE_PDP_KRATOS = 'marty.pdp.kratos';
export const FEATURE_REMOVE_CART_LOCAL_STORAGE = 'marty.cart.disable.localstorage';
export const FEATURE_CHECKOUT_STORE_CREDIT = 'marty.checkout.store.credit';
export const FEATURE_CHECKOUT_STORE_CREDIT_FORCE_START_DATE = 'marty.checkout.store.credit.force.start.date';
export const FEATURE_KRATOS_SHIPPING_TRACKING_ENABLED = 'marty.order.shipping.tracking.page';
export const FEATURE_EXCHANGES_DISABLE = 'marty.exchanges.disable';
// TODO: Remove once V2P3 is fully rolled out. https://taskei.amazon.dev/tasks/FEE-7956
export const FEATURE_SEARCH_FACETS_V2P3 = 'marty.search.facets.v2p3';
export const FEATURE_CART_APPLE_PAY = 'web.cart.apple.pay';
export const KILLSWITCH_APPLE_PAY_CART = 'marty.cart.applePay.turnOff';
export const FEATURE_PDP_AMAZON_REVERSE_SHARING = 'kratos.pdp.amazon.reverse.sharing.feature';
export const FEATURE_COOKIE_CONSENT = 'web.consent.cookie';
export const KILLSWITCH_PRIVACY_DATA_SHARING = 'marty.data.privacy';
export const FEATURE_UNLEASH_WIRING = 'marty.unleash.wiring';
export const FEATURE_ZCS_PTC_BASIC = 'kratos.zcs.ptc.basic';
export const FEATURE_ZCS_PTC_CATALOG = 'kratos.zcs.ptc.catalog';
